import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import BusinessCreateForm from '../components/businesses/BusinessCreateForm';
import SocietyContextMobileNav from '../components/societies/SocietyContextMobileNav';

const BusinessCreatePage = () => {
  const { societySlug } = useParams();

  return (
    <PageLayout title="PakPoints">
      <Helmet>
        <title>Create Business - PakPoints</title>
        <meta name="description" content="Create a new business listing to share with your community on PakPoints" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {societySlug ? (
          <SocietyContextMobileNav societySlug={societySlug} activeSection="businesses" />
        ) : null}
        <div className="py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <BusinessCreateForm />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default BusinessCreatePage;
